import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { useCallback } from 'react';

import { useAppDispatch } from '@/redux/hooks';
import {
    toggleEmailListSubscription,
    ToggleEmailListSubscriptionParams,
} from '@/redux/modules/account/notifications/emailList/emailList.actions';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

/**
 * Toggles an email list subscription and shows an error toast if the save fails.
 * Resolves to whether the save succeeded; never rejects.
 */
export const useToggleEmailListSubscription = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    return useCallback(
        async (params: ToggleEmailListSubscriptionParams) => {
            try {
                await dispatch(toggleEmailListSubscription(params)).unwrap();
                return true;
            } catch {
                toast('error', {
                    description: String(formatMessage(['toastMessages', 'descriptions', 'emailPreferenceSaveFailed'])),
                    title: String(formatMessage(['toastMessages', 'titles', 'error'])),
                });
                return false;
            }
        },
        [dispatch, formatMessage]
    );
};
